import { Component, OnInit } from '@angular/core';
import { AreasService } from '../services/areas-services';
import { TransactionResult } from '../../../../core/services/interfaces/transaction-result';
import { MatDialog } from '@angular/material/dialog';
import { NotificationService } from '../../../../core/services/notification/notification.service';
import {DatePipe} from '@angular/common';
import { Router } from '@angular/router';
import { TranslateApplicationService } from '../../../../core/translate/translate-application-service';
import { IAreas } from '../Interfaces/IAreas';
import { AreaDetail } from './area-detail/area-detail';
import { IScreens } from '../Interfaces/IScreens';
import { RolesService } from '../services/roles-service';

declare var jQuery:any;

@Component({
  selector: 'app-areas',
  templateUrl: './areas.component.html',
  styleUrls: ['./areas.component.scss']
})
export class AreasComponent implements OnInit {
  listData: IAreas[];
  loading = false;
  station: string = 'TABLE';
  columns: Array<any> = ['area', 'requirednda', 'building_name', 'strcreationdate', 'employeecreatorname', 'strlastupdated', 'employeeupdatername', 'changestatuscolumn', 'editcolumn'];
  displayedColumns: Array<string> = this.columns.map(c => c.columnDef);

  constructor(private areaService: AreasService,
    private notificationService: NotificationService,
    public dialog: MatDialog,
    private datePipe: DatePipe,
    public router: Router,
    public translate: TranslateApplicationService,
    private roleService: RolesService
  ) { }

  ngOnInit() {
    this.loading = true;
    this.roleService.EmployeeHasPermissionToScreen('Areas').subscribe(
    (result: TransactionResult<IScreens[]>) => {
      this.loading = false;
      if (result.success) {
        if (result.data == null || result.data.length == 0)
          this.router.navigateByUrl('/main/without-permission');
      }
      else{
        this.ErrorMessage('ROLES.Error_employee_has_permission');
        this.router.navigateByUrl('/main/without-permission');
      }
    },
    (error: any) => { 
      this.ErrorAlert(error); this.loading = false; 
    });
    const component = this;
    jQuery(".btnReload").click(function(){
      component.GetAreas();
    });
    this.GetAreas();
  }

  GetAreas() {
    this.loading = true;
    this.areaService.GetAreasWithBuildings().subscribe( 
    (result: TransactionResult<IAreas[]>) => {
      this.loading = false;
      if (result.success) {
        this.listData = result.data;
        this.listData.forEach(element => {
          element.strcreationdate = this.datePipe.transform(element.creationdate,"yyyy-MM-dd HH:mm:ss");
          element.strlastupdated = this.datePipe.transform(element.lastupdated,"yyyy-MM-dd HH:mm:ss");
        });
      }
      else{
        this.ErrorAlert(result.message);
      }
    },
    (error: any) => { 
      this.ErrorAlert(error); this.loading = false; 
    });
  }

  AddArea() {
    const dialogRef = this.dialog.open(AreaDetail, {
      data: {}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) this.GetAreas();
    });
  }

  EditArea(item: IAreas) {
    const dialogRef = this.dialog.open(AreaDetail, {
      data: item
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) this.GetAreas();
    });
  }

  ChangeStatus(item: IAreas){
    this.areaService.ChangeStatusArea(item).subscribe( 
    (result: TransactionResult<IAreas[]>) => {
      this.loading = false;
      if (result.success) {
        this.Alert();
        this.GetAreas();
      }
      else{
        this.ErrorMessage('ERROR.Error_change_status');
      }
    },
    (error: any) => { 
      this.ErrorAlert(error); this.loading = false; 
    });
  }

  ChangeStatusRequiredNDA(item: IAreas){
    this.areaService.ChangeStatusRequiredNDA(item).subscribe( 
    (result: TransactionResult<IAreas[]>) => {
      this.loading = false;
      if (result.success) {
        this.Alert();
        this.GetAreas();
      }
      else{
        this.ErrorMessage('ERROR.Error_change_status');
      }
    },
    (error: any) => { 
      this.ErrorAlert(error); this.loading = false; 
    });
  }

  Alert() {
    this.notificationService.AddAlert({
      icon: 'all_inbox',
      title: 'Success',
      message: this.translate.TranslateKey('COMPLETE'),
      shown: true
    });
  }
  
  ErrorAlert(message: any) {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: 'Error',
			message: message,
			shown: true,
		});
  }

  ErrorMessage(message: any) {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: 'Error',
			message: this.translate.TranslateKey(message),
			shown: true,
		});
	}
}
